import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type HttpErrorPayload = {
  msg: string;
  errorCode?: string | number;
  correlationId?: string;
};

type ErrorState = {
  msg: string | null;
  errorCode?: string | number;
  correlationId?: string;
};

const initialState: ErrorState = {
  msg: null,
  errorCode: undefined,
  correlationId: undefined,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    httpError: (state, action: PayloadAction<HttpErrorPayload>) => {
      state.msg = action.payload.msg || '';
      state.errorCode = action.payload.errorCode;
      state.correlationId = action.payload.correlationId;
    },
    errorReset: (state) => {
      state.msg = null;
      state.errorCode = undefined;
      state.correlationId = undefined;
    },
    executeGraphQLErrorHandler: (state, action: PayloadAction<HttpErrorPayload>) => {
      state.msg = action.payload?.msg;
      state.errorCode = action.payload?.errorCode;
    },
  },
});

export const { httpError, errorReset, executeGraphQLErrorHandler } = errorSlice.actions;
export default errorSlice.reducer;
